import React from "react";

// @ts-ignore
import { createStyles, makeStyles } from "@material-ui/core/styles";

import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";

import { SERVER_URI } from "../../constants";

const useStyles = makeStyles((theme) =>
  createStyles({
    horizontalList: {
      display: "flex",
      flexDirection: "row",
      padding: 0,
    },
  })
);

interface Props {
  node: any;
}

function LiveDataMapList(props: Props) {
  const classes = useStyles(props);
  const { node } = props;
  return (
    <List
      dense
      className={classes.horizontalList}
      style={{ overflow: "auto", height: "100%" }}
    >
      {node.values.map((nodeValue: any, valueIndex: number) => (
        // <><img src={`${SERVER_URI}${nodeValue.iconURL}`} />{nodeValue.formattedValue}</>
        <ListItem key={valueIndex} disableGutters>
          <ListItemIcon style={{ minWidth: "24px" }}>
            {/* <NodeIcon subClass={nodeValue.subClass} __typename={"TagNode"} /> */}
            <img src={`${SERVER_URI}${nodeValue.iconURL}`} alt="" />
          </ListItemIcon>
          <ListItemText primary={nodeValue.formattedValue} />
        </ListItem>
      ))}
    </List>
  );
}

export default LiveDataMapList;
